<template>
  <div>
    <audio
      controls="controls"
      hidden
      src="../../../assets/err.mp3"
      ref="erraudio"
    ></audio>
    <audio
      controls="controls"
      hidden
      src="../../../assets/success.wav"
      ref="successaudio"
    ></audio>

    <van-tabs
      type="card"
      color="#ffffff"
      background="#aaaaaa"
      title-inactive-color="#000000"
      title-active-color="#000000"
      @click="tabsClick"
    >
      <van-tab title="出库扫描"></van-tab>
      <van-tab title="拍照"></van-tab>
    </van-tabs>

    <!--出库扫描 -->
    <div v-if="tabType === '出库扫描'">
      <!-- 车辆信息 -->
      <div>
        <p class="p-title">车辆信息</p>
        <div class="item-info">
          <ul class="item-ul">
            <li class="item-li">
              <div class="item-left">
                <span>车牌号码</span><span>{{ list.carNumber }}</span>
              </div>
            </li>
            <li class="item-li">
              <div class="item-right">
                <span>司机姓名</span><span>{{ list.driver }}</span>
              </div>
              <div class="item-left">
                <span>联系方式</span><span>{{ list.driverPhone }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 临柜信息 -->
      <div>
        <p class="p-title">出库单号【{{ list.outboundNo }}】</p>
        <div class="item-info">
          <ul class="item-ul">
            <li class="item-li">
              <div class="item-right">
                <span>参考单号</span><span>{{ list.orgOutboundNo }}</span>
              </div>
              <div class="item-left">
                <span>运输方式</span><span>{{ list.transportType }}</span>
              </div>
            </li>

            <li class="item-li">
              <div class="item-right">
                <span>柜号/SO号</span
                ><span
                  >{{ list.containerNumber
                  }}{{ list.soNumber != null ? "/" + list.soNumber : "" }}</span
                >
              </div>
              <div class="item-left">
                <span>客户</span><span>{{ list.customName }}</span>
              </div>
            </li>
            <li class="item-li">
              <div class="item-right">
                <span>总箱数</span><span>{{ list.boxCount }}</span>
              </div>
              <div class="item-left">
                <span>已拣数</span><span>{{ list.pickCount }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 备注信息 -->
      <div>
        <p class="p-title">备注信息</p>
        <div class="item-info">
          <span>{{ list.remark }}</span>
        </div>
      </div>
      <p class="p-title">
        <span>扫码发货</span
        ><span class="scan-sum"
          ><el-button type="text" @click="toList(true)"
            >统计:总数{{ list.boxCount }}箱，已发{{ list.scanBoxCount }}箱<i
              class="el-icon-view el-icon--right"
            ></i></el-button
        ></span>
      </p>
      <div class="scanBox">
        <div style="width: 75%">
          <van-field
            size="small"
            v-model="list.scanCode"
            placeholder="扫码装柜,只支持箱唛"
            right-icon="scan"
            @click-right-icon="scanDoc"
            @keyup.13="scanSend()"
            @focus="codeFocus"
            ref="scanCode"
          />
        </div>
        <div class="toSearch-box">
          <button class="sign-to" @click="SendPoints()">无箱唛,点数装柜</button>
        </div>
      </div>
      <p class="p-title">
        <span>扫码不发</span
        ><span class="scan-sum"
          ><el-button type="text" @click="toList(false)"
            >统计:不发{{ list.noScanBoxCount }}箱<i
              class="el-icon-view el-icon--right"
            ></i></el-button
        ></span>
      </p>
      <div class="scanBox">
        <div style="width: 75%">
          <van-field
            size="small"
            v-model="list.scanNoCode"
            placeholder="扫码不发,只支持箱唛"
            right-icon="scan"
            @click-right-icon="scanNoDoc"
            @keyup.13="scanNoSend()"
            @focus="codeFocus"
            ref="scanNoCode"
          />
        </div>
        <div class="toSearch-box">
          <button class="sign-to-no" @click="notSendPoints()">
            无箱唛,点数不发
          </button>
        </div>
      </div>
      <div>
        <p class="p-title">未发箱子新库位</p>
        <!-- 未发箱号搜索 -->
        <div class="avgInfo">
          <van-field
            size="small"
            v-model="locationValue"
            placeholder="库位"
            right-icon="scan"
            @click-right-icon="scan"
            @focus="storageFocus"
            @input="storageChange"
            ref="storage"
          />
        </div>
      </div>
      <div class="avgInfo">
        <van-field
          style="margin-right: 10px"
          v-model="carInStoreTime"
          name="carInStoreTime"
          :readonly="true"
          placeholder="柜车到场时间"
          @click="() => carTimeClick('inStore')"
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="overCarTime"
          name="overCarTime"
          :readonly="true"
          placeholder="封柜时间"
          @click="() => carTimeClick('carOver')"
          :rules="[{ required: true }]"
        />
      </div>
      <!-- 提交 -->
      <div class="putC_footer">
        <button class="submit-btn clear-btn" @click="submit(0)">
          保存草稿
        </button>
        <button class="submit-btn" @click="submit(1)">确认提交</button>
      </div>
      <van-popup v-model="showPicker" round position="bottom" :overlay="false">
        <van-picker
          show-toolbar
          confirm-button-text="确认"
          cancel-button-text="取消"
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
          :loading="loading"
          :item-height="20"
          :visible-item-count="5"
        />
      </van-popup>
    </div>

    <!-- 拍照 -->
    <div v-else>
      <div class="photo">
        <p class="p-title" style="border-bottom: 1px solid #ececec">出库照片</p>
        <div class="sign-photo-cpntent">
          <div class="sign-photo-box">
            <ul v-for="(item, i) in photoList" :key="i">
              <div v-for="(item2, i2) in item" :key="i2">
                <p>
                  <span class="red" v-if="item2.required">*</span
                  >{{ item2.text }}
                </p>
                <div class="sign-photo-item" v-if="imgObj[item2.name]">
                  <span class="delete-icon" @click="deleteImg(item2.name)"
                    >x</span
                  >
                  <img
                    :src="imgObj[item2.name]"
                    class="sign-photo-item-img"
                    alt=""
                    @click="previewImage(imgObj[item2.name])"
                  />
                </div>

                <div class="sign-photo-btn" v-else>
                  <div class="photo">
                    <input
                      class="img hidden"
                      @change="changeImg"
                      type="file"
                      name="cover"
                      ref="inputer"
                      accept="image/*"
                    />
                    <p @click="chooseImage(item2.id)">
                      <i class="el-icon-camera"></i>
                    </p>
                  </div>
                </div>
              </div>
            </ul>
          </div>
          <div class="sign-photo-save">
            <button class="submit-btn clear-btn" @click="submit(0)">
              保存草稿
            </button>
            <button class="submit-btn" @click="submit(1)">确认提交</button>
          </div>
        </div>
      </div>
    </div>
     <van-datetime-picker
            v-if="showTime"
            type="time"
            title="选择时间"
            :show-toolbar="true"
            :min-date="minDate"
            :max-date="maxDate"
            :value="currentTime"
            @confirm="onConfirmTimeSelect"
            @cancel="onCancelTimeSelect"
            confirm-button-text="确认"
            cancel-button-text="取消"
            class="picker"
          />
    <van-dialog
      v-model="showNoSend"
      title="点数不发"
      show-cancel-button
      confirmButtonText="确认"
      cancelButtonText="取消"
      @confirm="confirmNoSend"
    >
      <van-row type="flex" justify="center" align="center">
        <van-col span="14">进仓单号</van-col>
        <van-col span="4">已扫</van-col>
        <van-col span="6">不发({{ this.countchangeNum }})</van-col>
      </van-row>
      <div class="van-swipe-main">
        <van-swipe-cell v-for="(item, index) in deliveryNoSend" :key="index">
          <div class="list-div">
            <p>{{ item.deliveryOrdeNo }}</p>
            <p>{{ item.scanBoxCount }}</p>
            <p>
              <input
                type="number"
                class="downInp"
                v-model="item.pointsBoxCount"
              />
            </p>
          </div>
        </van-swipe-cell>
      </div>
    </van-dialog>

    <van-dialog
      v-model="showSend"
      title="点数装柜"
      show-cancel-button
      confirmButtonText="确认"
      cancelButtonText="取消"
      @confirm="confirmSend"
    >
      <van-row type="flex" justify="center" align="center">
        <van-col span="14">进仓单号</van-col>
        <van-col span="4">已扫</van-col>
        <van-col span="6">点数({{ this.countSendNum }})</van-col>
      </van-row>
      <div class="van-swipe-main">
        <van-swipe-cell v-for="(item, index) in deliverySend" :key="index">
          <div class="list-div">
            <p>{{ item.deliveryOrdeNo }}</p>
            <p>{{ item.scanBoxCount }}</p>
            <p>
              <input
                type="number"
                class="downInp"
                :disabled="item.pickCount == 0"
                v-model="item.pointsBoxCount"
              />
            </p>
          </div>
        </van-swipe-cell>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  DatetimePicker,
  Cell,
  Dialog,
  ImagePreview,
  Sticky,
} from "vant";
import { mixins } from "../mobileMixins";
import { DeleteScanBoxInfo } from "@/api/mobile/loading_api";
import { BaseApiUrl } from "@/api/axios_config";
import {
  getOutboundScan,
  ScanCodeNoDeliveryBox,
  OutboundScanSubmit,
  loadOut,
  submitBox,
  loadingBoxPoints,
  getPointsDetail,
} from "@/api/mobile/jy-outbound_api";
import { getWarehouseLocation } from "@/api/mobile/stock_api";
import axios from "axios";
export default {
  data() {
    return {
      timeType: "",
      currentTime: "",
      showPicker: false, // 控制时间选择器的显示
      showTime: false,
      minDate: new Date(2020, 0, 1), // 最小日期
      maxDate: new Date(2025, 11, 31), // 最大日期
      carInStoreTime: "",
      overCarTime: "",
      list: {},
      isOpen: false,
      tabType: "出库扫描",
      scanBoxCode: "",
      scanNoSendBoxCode: "",
      isAllSendBox: false,
      showNoSend: false,
      showSend: false,
      allBoxList: [],
      deliveryNoSend: [],
      deliverySend: [],
      countchangeNum: 0,
      countSendNum: 0,
      loading: false,
      locationValue: "",
      columns: [],
      currentImg: "",
      focusType: "",
      imgObj: {
        // 图片类型 1.车牌照 2.空柜照 3.托运单 4.未关门照 5.半关门照 6关门照 7.锁封照 8.其他 9.其他1
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: "",
        img6: "",
        img7: "",
        img8: "",
        img9: "",
      },
      photoList: [
        [
          {
            name: "img1",
            text: "车牌照",
            id: 1,
            required: false,
          },
          {
            name: "img2",
            text: "空柜照",
            id: 2,
            required: false,
          },
          {
            name: "img3",
            text: "托运单",
            id: 3,
            required: false,
          },
        ],
        [
          {
            name: "img4",
            text: "未关门照",
            id: 4,
            required: false,
          },
          {
            name: "img5",
            text: "半关门照",
            id: 5,
            required: false,
          },
          {
            name: "img6",
            text: "关门照",
            id: 6,
            required: false,
          },
        ],
        [
          {
            name: "img7",
            text: "锁封照",
            id: 7,
            required: false,
          },
          {
            name: "img8",
            text: "其他",
            id: 8,
            required: false,
          },
          {
            name: "img9",
            text: "其他1",
            id: 9,
            required: false,
          },
        ],
      ],
      imgFiles: [],
      saveImgUrlArr: [],
      inpType: "",
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [DatetimePicker.name]: DatetimePicker,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.name]: ImagePreview,
    [Sticky.name]: Sticky,
    [Field.name]: Field,
  },
  mixins: [mixins],
  computed: {
  },
  created() {
    this.init();
  },

  methods: {
    extractedTime(type,changeTime) {
      console.info(changeTime);
      const date = new Date(changeTime);
      const hours = String(date.getHours()).padStart(2, '0');
      console.info(hours);
      const minutes = String(date.getMinutes()).padStart(2, '0');
      console.info(minutes);
      return `${type} ${hours}:${minutes}`;
    },
    getCurrentTime() {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      this.currentTime = `${hours}:${minutes}`;
    },
    formatterDate(day) {
      return day;
    },
    
    onConfirmTimeSelect(date) {
      console.info(date);
      this.showTime = false;
      if (this.timeType == "inStore") {
        this.carInStoreTime = "柜车到场 " + date;
      } else {
        this.overCarTime = "封柜时间 " + date;
      }
    },
    onCancelTimeSelect() {
      this.showTime = false;
    },
    carTimeClick(timeType) {
      this.getCurrentTime();
      this.timeType = timeType;
      this.showTime = true;
    },
    //单据号获取焦点
    codeFocus() {
      this.showPicker = false;
    },
    scanDoc() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.list, "scanCode", a.resultStr);
        },
      });
    },
    scanNoDoc() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.list, "scanNoCode", a.resultStr);
        },
      });
    },
    scanSend() {
      let tfDeliveryOrderID = 0;
      const { tfOutboundID, scanCode } = this.list;
      const markMap = this.allBoxList.find((item) => item.boxMark === scanCode);
      if (markMap == undefined) {
        //自发货完整匹配
        const headAllMap = this.allBoxList.find(
          (item) => item.markHead === scanCode
        );
        if (headAllMap == undefined) {
          //箱唛号识别不到，去掉后6位，判断唛头
          const markHeadNo = scanCode.slice(0, -6);
          const headMap = this.allBoxList.find(
            (item) => item.markHead === markHeadNo
          );
          if (headMap == undefined) {
            this.showsound(false);
            Toast.fail("无此箱唛号");
          } else {
            tfDeliveryOrderID = headMap.tfDeliveryOrderID;
          }
        } else {
          tfDeliveryOrderID = headAllMap.tfDeliveryOrderID;
        }
      } else {
        tfDeliveryOrderID = markMap.tfDeliveryOrderID;
      }
      if (tfDeliveryOrderID > 0) {
        submitBox({
          tfOutboundID: tfOutboundID,
          boxMark: scanCode,
          isSend: true,
          tfDeliveryOrderID: tfDeliveryOrderID,
        }).then((res) => {
          if (res.status === 200) {
            this.showsound(true);
            this.list.scanBoxCount = this.list.scanBoxCount + 1;
          } else {
            this.showsound(false);
            Toast.fail(res.msg);
          }
          // 直接访问 input 元素并选择文本
          const input = this.$refs.scanCode.$el.querySelector("input");
          if (input) {
            input.select(); // 选择文本
          }
        });
      }
    },

    scanNoSend() {
      let tfDeliveryOrderID = 0;
      const { tfOutboundID, scanNoCode } = this.list;
      const markMap = this.allBoxList.find(
        (item) => item.boxMark === scanNoCode
      );
      if (markMap == undefined) {
        //箱唛号识别不到，去掉后6位，判断唛头
        const markHeadNo = scanNoCode.slice(0, -6);
        const headMap = this.allBoxList.find(
          (item) => item.markHead === markHeadNo
        );
        if (headMap == undefined) {
          this.showsound(false);
          Toast.fail("无此箱唛号");
        } else {
          tfDeliveryOrderID = headMap.tfDeliveryOrderID;
        }
      } else {
        tfDeliveryOrderID = markMap.tfDeliveryOrderID;
      }
      submitBox({
        tfOutboundID: tfOutboundID,
        boxMark: scanNoCode,
        isSend: false,
        tfDeliveryOrderID: tfDeliveryOrderID,
      }).then((res) => {
        if (res.status === 200) {
          this.showsound(true);
          this.list.noScanBoxCount = this.list.noScanBoxCount + 1;
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
        // 直接访问 input 元素并选择文本
        const input = this.$refs.scanNoCode.$el.querySelector("input");
        if (input) {
          input.select(); // 选择文本
        }
      });
    },
    loadOut() {
      const that = this;
      if (this.list.scanCode == undefined) {
        this.showsound(false);
        Toast.fail("请输入或扫描单号");
        this.$refs.scanCode.focus();
        return;
      }
      const { tfOutboundID } = this.list;
      const data = {
        TFOutboundID: tfOutboundID,
        ScanCode: this.list.scanCode,
      };
      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      loadOut(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          Toast.success("操作成功");
          setTimeout(() => {
            that.getDetail();
          }, 500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
        // 使用 $nextTick 确保 DOM 更新后再执行选择
        this.$nextTick(() => {
          // 直接访问 input 元素并选择文本
          const input = this.$refs.scanCode.$el.querySelector("input");
          if (input) {
            input.select(); // 选择文本
          }
        });
      });
    },
    confirmNoSend() {
      Toast.loading({
        message: "保存中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      const { tfOutboundID } = this.list;
      const data = {
        TFOutboundID: tfOutboundID,
        IsSend: false,
        Points: this.deliveryNoSend,
      };

      loadingBoxPoints(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          Toast.success(res.msg || "点数成功");
          this.getDetail();
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },

    confirmSend() {
      Toast.loading({
        message: "保存中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      const { tfOutboundID } = this.list;
      const data = {
        TFOutboundID: tfOutboundID,
        IsSend: true,
        Points: this.deliverySend,
      };

      loadingBoxPoints(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          Toast.success(res.msg || "点数成功");
          this.getDetail();
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },
    
    onConfirm(val) {
      this.locationValue = val;
      this.showPicker = false;
    },
    init() {
      const that = this;
      window.addEventListener(
        "resize",
        function () {
          if (that.viewportHeight - this.innerHeight > 50) {
            // 键盘弹起
            if (that.focusType === "locationCode") {
              that.showPicker = false;
            }
            const activeElement = document.activeElement;
            if (
              activeElement.tagName === "INPUT" ||
              activeElement.tagName === "TEXTAREA"
            ) {
              that.$nextTick(function () {
                that.$refs.storage.focus
                  ? (that.$refs.storage.scrollTop = 100)
                  : (that.$refs.boxCount.scrollTop = 100);
              });
            }
          } else {
            // 键盘收起
            if (that.focusType === "locationCode") {
              that.showPicker = true;
            }
          }
        },
        true
      );
      this.getDetail();
      // that.$nextTick(function () {
      //   that.$refs.scanCode.focus();
      // });
    },

    getDetail() {
      const data = {
        outboundNo: this.$route.query.outboundNo,
      };
      getOutboundScan(data).then((res) => {
        if (res.status === 200) {
          const { response } = res;
          this.list = response;
          this.carInStoreTime=response.carInStoreTime==null?"":this.extractedTime("柜车到场",response.carInStoreTime);
          this.overCarTime=response.overCarTime==null?"":this.extractedTime("封柜时间",response.overCarTime);
          this.locationValue = response.storages;
          this.curTransportType = response.transportType;
          this.handleImgRequired();
          this.allBoxList = response.boxList;
          if (response.imgUrlList && response.imgUrlList.length) {
            response.imgUrlList.forEach((item, i) => {
              this.$set(
                this.imgObj,
                `img${item.labelingType}`,
                `data:image/jpg;base64,${item.urlPath}`
              );
              this.saveImgUrlArr.push({
                imageUrl: item.imgUrl,
                imageType: item.labelingType,
              });
            });
          }
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    getPointsDetail(isSend) {
      const data = {
        outboundNo: this.$route.query.outboundNo,
        isSend: isSend,
      };
      console.info(data);
      getPointsDetail(data).then((res) => {
        if (res.status === 200) {
          const { response } = res;
          if (isSend) {
            this.deliverySend = response || [];
            this.countSendNum = this.deliverySend.reduce(
              (total, delivery) => total + delivery.pointsBoxCount,
              0
            );
          } else {
            this.deliveryNoSend = response || [];
            this.countchangeNum = this.deliveryNoSend.reduce(
              (total, delivery) => total + delivery.pointsBoxCount,
              0
            );
          }
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    // 库位获取焦点
    storageFocus() {
      this.showPicker = true;
      this.focusType = "locationCode";
      this.storageChange();
    },

    storageChange() {
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      const { warehouseId } = _warehouse;
      console.info(this.locationValue);
      //if (this.columns.length > 0) return;

      const data = { locationCode: this.locationValue, warehouseId };
      this.loading = true;

      getWarehouseLocation(data).then((res) => {
        this.loading = false;
        if (res.status === 200) {
          const { response } = res;

          try {
            let arr = [];
            response.forEach((item) => {
              arr.push(item.locationCode);
            });
            this.columns = arr;
          } catch {}
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    tabsClick(n, t) {
      this.tabType = n === 0 ? "出库扫描" : "拍照";
      console.log(this.saveImgUrlArr);
    },

    focusInp(type) {
      this.inpType = type;
    },

    scan(type) {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.scanNoSendBoxCode = a.resultStr;
          that.getNoSendBoxCode();
        },
      });
    },

    inputNum(target) {
      let timeNow = target.timeStamp;
      this.scanArr.push(timeNow);
      for (let i in this.scanArr) {
        if (
          Math.ceil(this.scanArr[this.scanArr.length - 1]) -
            Math.ceil(this.scanArr[this.scanArr.length - 2]) <
          30
        ) {
          //if(this.inpType == 'scanBoxCode'){
          // this.$refs.scanInp1.blur()
          /**
                     * if(this.inpType == 'scanBoxCode'){
					    this.$refs.scanInp1.blur()
                    }
                    if(this.inpType == 'scanNoSendBoxCode'){
					    this.$refs.scanInp2.blur()
                    }
                     */
        }
      }
    },

    getNoSendBoxCode() {
      if (!this.scanNoSendBoxCode) return;
      const { tfOutboundID } = this.list;
      ScanCodeNoDeliveryBox({
        customerBox: this.scanNoSendBoxCode,
        tfOutboundID: tfOutboundID,
      }).then((res) => {
        if (res.status === 200) {
          this.list.noScanBoxCount = this.list.noScanBoxCount + 1;
        } else {
          Toast.fail(res.msg);
        }
      });
      this.scanNoSendBoxCode = "";
      this.$refs.scanInp2.focus();
    },

    delBox(id) {
      Toast.loading({
        message: "删除中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      DeleteScanBoxInfo({ recordId: id }).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.getDetail();
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    checkPhoto(subType) {
      const that = this;

      if (!this.saveImgUrlArr.length && subType == 1) {
        this.showsound(false);
        Toast("请上传带*号的必填图片");
        return false;
      }

      let flag = false;
      this.photoList.forEach((item, i) => {
        item.forEach((item2, i2) => {
          let arr = [];
          this.saveImgUrlArr.forEach((item3, i) => {
            arr.push(item3.imageType);
          });
          if (item2.required && !arr.includes(item2.id)) {
            flag = true;
          }
        });
      });

      if (flag && subType == 1) {
        this.showsound(false);
        this.$message({
          message: "请上传带*号的必填图片",
          type: "error",
        });
        return false;
      }

      return true;
    },
    notSendPoints() {
      this.getPointsDetail(false);
      this.showNoSend = true;
    },
    SendPoints() {
      this.getPointsDetail(true);
      this.showSend = true;
    },
    showsound(isSuccess) {
      if (isSuccess) {
        this.$refs.successaudio.currentTime = 0;
        this.$refs.successaudio.play();
      } else {
        this.$refs.erraudio.currentTime = 0;
        this.$refs.erraudio.play();
      }
    },
    submit(subType) {
      //0草稿1提交
      const that = this;

      if (!this.checkPhoto(subType)) return;
      const { tfOutboundID } = this.list;
      const data = {
        tfOutboundID: tfOutboundID,
        storages: this.locationValue,
        imageUrls: this.saveImgUrlArr,
        subType: subType,
        carInStoreTime:this.carInStoreTime,
        overCarTime:this.overCarTime
      };

      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      OutboundScanSubmit(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          Toast.success(res.msg || "提交成功");
          if (subType == 1) {
            setTimeout(function () {
              that.$router.go(-1);
            }, 1500);
          }
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },

    deleteImg(type) {
      this.$set(this.imgObj, type, "");

      this.saveImgUrlArr.forEach((item, i) => {
        const m = type.split("")[3];
        if (m == item.imageType) {
          this.saveImgUrlArr.splice(i, 1);
        }
      });
    },

    changeImg() {
      const img = document.getElementsByClassName("img")[0];

      if (!img.files.length) return;

      this.handleFiles(img.files);

      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.submitImg();
    },

    chooseImage(num) {
      this.currentImg = num;
      document.getElementsByClassName("img")[0].value = "";
      document.getElementsByClassName("img")[0].click();
    },

    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },

    handleFiles(files) {
      const that = this;

      var file = files;

      const { type, name } = file[0];

      var imageType = /^image\//;
      if (!imageType.test(type)) {
        return;
      }

      var reader = new FileReader();
      reader.onload = function (e) {
        that.$set(that.imgObj, `img${that.currentImg}`, e.target.result);
      };
      reader.readAsDataURL(file[0]);
    },

    submitImg() {
      const that = this;

      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          this.saveImgUrlArr.push({
            imageUrl: res.data.response[0].urlPath,
            imageType: this.currentImg,
          });
          this.imgFiles = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },

    toList(isSend) {
      console.info(isSend);
      const { tfOutboundID } = this.list;
      this.$router.push({
        path: "/mobile/jy-outboundScanBoxList",
        query: { tfOutboundID, isSend: isSend },
      });
    },

    openOrclose() {
      this.isOpen = !this.isOpen;
    },

    handleImgRequired() {
      this.photoList.forEach((item, i) => {
        item.forEach((item2, i2) => {
          this.$set(this.photoList[i][i2], "required", false);
          if (this.curTransportType == "空运" && [1, 7].includes(item2.id)) {
            this.$set(this.photoList[i][i2], "required", true);
          }
          if (
            (this.curTransportType == "海运" || this.curTransportType == "") &&
            [1, 2, 6, 7].includes(item2.id)
          ) {
            this.$set(this.photoList[i][i2], "required", true);
          }
        });
      });
    },
  },

  watch: {
    isAllSendBox: function (n, o) {
      if (n === true) {
        this.allSend();
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.picker {
  position: absolute;
  top: 630px; /* 假设文本框高度为30px，再往下10px，具体根据实际情况调整 */
  left: 0;
  width: 100%; /* 与文本框同宽 */
  z-index: 100; /* 确保覆盖按钮 */
}
.time-input {
  width: 100%; /* 适应宽度 */
  padding: 10px; /* 内边距 */
  border: 1px solid #ccc; /* 边框样式 */
  border-radius: 4px; /* 圆角 */
  font-size: 16px; /* 字体大小 */
  cursor: pointer; /* 鼠标指针样式 */
}

.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    .item-li {
      display: flex;
      align-content: flex-start;
      & > div {
        line-height: 25px;
        flex: 1;
        & > span {
          vertical-align: text-top;
          &:first-child {
            padding-right: 10px;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}
.van-swipe-main {
  .list-div {
    display: flex;
    padding: 0 4px;
    text-align: center;
    > p:first-child {
      width: 58.33333333%;
    }
    > p:nth-child(2) {
      width: 20.83333333%;
    }
    > p:last-child {
      width: 20.83333333%;
      input {
        width: 80%;
      }
    }
  }
}
.conventionalBox-info {
  font-size: 14px;
  .signInDetail-btnBox {
    background-color: #fbf9fe;
    padding: 10px;
    border-bottom: 1px solid #cccccc;
    li {
      line-height: 40px;
      white-space: nowrap;
      display: flex;
      align-items: baseline;
    }
    .volume {
      min-width: 10%;
      max-width: 27%;
      height: 22px;
      line-height: 22px;
      font-size: 12px;
      border: 0;
      background-color: #fbf9fe;
      border-bottom: 1px solid #757474;
      outline: none;
      margin: 0 5px;
      padding: 0 5px;
      box-sizing: border-box;
    }
    &:last-child {
      border-bottom: 0;
    }
  }
}
.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
}
.hidden {
  display: none;
}
.addInfo {
  position: absolute;
  right: 1%;
  color: #027db4;
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  margin-top: 2px;
  padding-left: 10px;
  font-size: 14px;
}
.avgInfo {
  padding: 2px 10px;
  display: flex;
}
.btn-other {
  height: 36px !important;
  min-width: 48% !important;
}
.add {
  border: 2px dashed #ccc;
  width: 100%;
  text-align: center;
  line-height: 15px;
  color: #ccc;
  margin: 5px 0;
}
.add:hover {
  border-color: rgb(151, 151, 151);
  color: rgb(151, 151, 151);
}
.btnBox-left {
  width: 100%;
  padding-right: 5px;
}
.btnBox-right {
  width: 100%;
  padding-left: 5px;
}
.search-box {
  text-align: center;
  padding: 3% 12% 1.5%;
}
::v-deep .van-col {
  text-align: center;
  background-color: #f2f2f2;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}
.list {
  .list-div {
    display: flex;
    height: 43px;
    line-height: 43px;
    border-bottom: 1px solid #ccc;
    & > p {
      flex: 1;
      text-align: center;
      margin: 0;
      & > .downInp {
        width: 55%;
        border: 1px solid #ccc;
        height: 80%;
        text-align: center;
      }
    }
  }
}

::v-deep .van-tabs__nav--card {
  margin: 0;
  border: 0;
}
::v-deep .van-tabs__nav,
.van-tabs__nav--card {
  border-bottom: 1px solid #ccc !important;
}
.isAllSendBox {
  & > div {
    float: right;
    font-size: 13px;
  }
}
.noSend-list {
  border: 1px solid #908d8d;
  .noSend-list-item {
    border-bottom: 1px solid #908d8d;
    &:last-child {
      border-bottom: 0;
    }
    .noSend-list-left {
      background-color: #facd91;
      text-align: left;
      padding-left: 30px;
    }
    .noSend-list-right {
      background-color: #35495e;
      color: #fff;
    }
  }
}

.putC_footer {
  margin-top: 10px;
  padding: 0 3%;
}

.submit-btn {
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 15px;
  border: 0;
  margin-bottom: 15px;
}

.clear-btn {
  background-color: #cccccc;
}
.unSend-btn {
  background-color: #f02222;
}

.sign-photo-box {
  margin: 5px 10px 10px;
  box-sizing: border-box;
  ul {
    display: flex;
    & > div {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        font-size: 13px;
      }
    }
    .sign-photo-item {
      width: 100px;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;
      box-shadow: 0px 0px 7px -1px #cccccc;
      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }
      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }
    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 100px;
      .photo {
        height: 100px;
        background-color: #faf9fc;
        position: relative;
        box-shadow: 0px 0px 7px -1px #cccccc;
        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;
          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
.scanBox {
  display: flex;
  padding: 10px;
  margin-bottom: -15px;
}
.scan-sum {
  padding-left: 20px;
  margin-bottom: -15px;
}
.toSearch-box {
  margin-left: 3%;
  width: 200px;
}
.sign-to {
  height: 80%;
  width: 100%;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  border: 0;
}
.sign-to-no {
  height: 80%;
  width: 100%;
  border-radius: 5px;
  background-color: #ec808d;
  color: #fff;
  border: 0;
}
.sign-photo-save {
  padding: 20px 10px;
}

@media screen and (max-width: 350px) {
  .sign-photo-box ul .sign-photo-item {
    width: 85px;
    height: 85px;
  }
  .sign-photo-box ul .sign-photo-btn {
    width: 85px;
    .photo {
      height: 85px;
    }
  }
}
</style>